import "../../Assets/css/MegaMenu.css";
import MegaMenu from "../Front/themes/showcase/Header/MegaMenu";
const Header = () => {
  return <MegaMenu />;
};

export default Header;
